<template>
    <v-container>
        <v-btn
                @click="newCovidPatient" large color="primary">Nuevo
        </v-btn>
        <v-layout>
            <v-flex>
                <div>
                    <v-layout>
                        <v-flex xs12 sm6 offset-sm6>
                            <v-text-field
                                    v-model="$store.state.covidAlarmSearch"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
            <v-dialog
                    v-model="dialog"
                    max-width="500px"
                    transition="dialog-bottom-transition"
                    scrollable>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialog = false" @click="cleanData">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Editar paciente</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout>
                                <v-flex xs12 sm7 offset-sm1>
                                    <v-text-field
                                            name="identificacion"
                                            label="Identificación"
                                            id="code"
                                            :rules="[v => !!v || 'El código es requerido', v => (v && v.length <= 10) || 'El código debe tener menos de 10 caracteres']"
                                            required
                                            v-model="covidPatient.identification"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="nombre"
                                            label="Nombre"
                                            id="nombre"
                                            :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                                            v-model="covidPatient.name"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="apellido"
                                            label="Apellido"
                                            id="apellido"
                                            :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                                            v-model="covidPatient.lastName"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-select
                                            v-model="covidPatient.company"
                                            :items="$store.state.companies"
                                            item-value="id"
                                            item-text="name"
                                            :rules="[v => !!v || 'Cliente es requerido']"
                                            label="Cliente"
                                            @change="loadAgency"
                                            return-object
                                            persistent-hint
                                            required
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-select
                                            v-model="covidPatient.agency"
                                            :items="$store.state.companyAgencies"
                                            item-value="id"
                                            item-text="name"
                                            :rules="[v => !!v || 'Agencia es requerida']"
                                            label="Sucursal/agencia/planta"
                                            return-object
                                            persistent-hint
                                            required
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm6 offset-sm4>
                                    <div>
                                        <v-btn :disabled="!valid"
                                               @click="saveData" large color="primary">Guardar
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <div style="flex: 1 1 auto;"></div>
                </v-card>
            </v-dialog>
        </v-layout>
        <h3 class="primary--text">Lista de Pacientes</h3>
        <v-data-table
                :headers="headers"
                :items="covidPatientList"
                class="elevation-1"
                sort-icon="mdi-menu-down"
                :search="$store.state.covidAlarmSearch"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.identification }}</td>
                <td class="text-xs-left">{{ props.item.uniqueCode }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.lastName }}</td>
                <td class="text-xs-left">{{ props.item.phone }}</td>
                <td class="text-xs-left">{{ props.item.company.name }}</td>
                <td v-if="props.item.status == 'ACTIVO'" class="text-xs-left">{{ props.item.status == "ACTIVO" ? "APTO"
                    : "NO APTO" }}
                </td>
                <td v-if="props.item.status == 'INACTIVO'" class="text-xs-left"><a
                        @click="openDialogAptitudeWork(props.item.id)">NO APTO</a></td>
                <td>
                    <v-tooltip top>
                        <v-btn
                                fab dark
                                small @click="editItem(props.item)"
                                slot="activator"
                                color="primary">
                            <v-icon dark>edit</v-icon>
                        </v-btn>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                            <v-icon dark>delete</v-icon>
                        </v-btn>
                        <span>Eliminar</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn
                                fab dark
                                small @click="editDoctorAsistant(props.item)"
                                slot="activator"
                                color="primary">
                            <v-icon dark>person</v-icon>
                        </v-btn>
                        <span>Asignar Doctor y Asistente</span>
                    </v-tooltip>
                </td>
                <td>
                    <a @click="getAlarms(props.item)">Alarmas</a>
                </td>
                <td>

                    <a @click="getEvolutions(props.item)">Evolución</a>
                </td>
                <td>
                    <a @click="getAptitudeWork(props.item)">Aptitud trabajo</a>

                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ $store.state.covidAlarmSearch }}".
            </v-alert>
        </v-data-table>
        <v-layout>
            <v-flex
                    xs12
                    md12
            >
                <table>
                    <td>
                        <v-btn @click="getCovidPatientAlarmReport" small color="primary">
                            Generar reporte de alarmas
                            <v-icon right dark>cloud_download</v-icon>
                        </v-btn>
                    </td>
                    <td>
                        <v-btn @click="getCovidPatientAlarmEvolutionReport" small color="secondary">
                            Generar reporte de evolución
                            <v-icon right dark>cloud_download</v-icon>
                        </v-btn>
                    </td>
                </table>
            </v-flex>
        </v-layout>
        <v-dialog
                v-model="dialogDownloadReportAlarm"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Reporte generado exitosamente.</span>
                </v-card-title>
                <div align="center">
                    <a :href="urlDownloadReport">Descargar Reporte</a>
                </div>

                <v-card-actions>
                    <br>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogDownloadReportAlarm = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="showAptitudeWorkDialog"
                max-width="500px"
                persistent
        >
            <v-card>
                <v-card-title>
                    <span>Por favor describa el motivo de cambiar el estado a APTO</span>
                </v-card-title>

                <v-form ref="formMotivo" v-model="validMotivo" lazy-validation>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-textarea
                                    name="motivo"
                                    box
                                    label="Motivo"
                                    auto-grow
                                    v-model="motivoCambioEstado"
                                    :rules="[v => !!v || 'Motivo es requerido']"
                                    required
                                    maxlength="20000"
                            ></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-form>
                <v-card-actions>
                    <v-btn color="secondary" flat @click="showAptitudeWorkDialog = false">Cerrar</v-btn>
                    <v-btn :disabled="!validMotivo"
                           @click="addAptitudeWork" flat color="primary">Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogDoctorAsistant"
                width="500px"
                transition="dialog-bottom-transition"
                scrollable>
            <v-card tile>
                <v-toolbar card dark color="nav_background_color">
                    <v-btn icon dark @click.native="dialogDoctorAsistant = false; $store.state.progress = false;" @click="cleanData">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Asignar doctor y asistente</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>

                        <v-layout>
                            <v-flex xs12 sm10 offset-sm1>
                                <v-select
                                        v-model="covidPatient.userDoctor"
                                        :items="usersByCompany"
                                        item-text="completeName"
                                        item-value="id"
                                        :rules="[v => !!v || 'La asignación del doctor es requerido']"
                                        label="Doctor"
                                        return-object
                                        persistent-hint
                                        required
                                ></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm10 offset-sm1>
                                <v-select
                                        v-model="covidPatient.userAsistant"
                                        :items="usersByCompany"
                                        item-value="id"
                                        item-text="completeName"
                                        label="Asistente"
                                        return-object
                                        persistent-hint
                                ></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm6 offset-sm4>
                                <div>
                                    <v-btn :disabled="!valid"
                                           @click="saveData" large color="primary">Guardar
                                    </v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
    import CovidPatient from "../../model/CovidPatient";

    const sha = require('js-sha256');
    export default {
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                urlDownloadReport: "",
                statusItems: ['ACTIVO',
                    'INACTIVO'],
                headers: [
                    {text: 'Identificacion', value: 'identification'},
                    {text: 'Código Único', value: 'uniqueCode'},
                    {text: 'Nombre', value: 'name'},
                    {text: 'Apellido', value: 'lastName'},
                    {text: 'Teléfono', value: 'telefono'},
                    {text: 'Empresa', value: 'company.name'},
                    {text: 'Estado', value: 'status'},
                    {text: 'Opciones', value: 'options'},
                    {text: 'Alarmas', value: 'alarm'},
                    {text: 'Evolución', value: 'evolution'},
                    {text: 'AptitudTrabajo', value: 'aptitudeWork'}

                ],
                editedIndex: -1,
                covidPatient: new CovidPatient(),
                covidPatientList: [],
                dialogDownloadReportAlarm: false,
                showAptitudeWorkDialog: false,
                motivoCambioEstado: "",
                validMotivo: false,
                covidPatientId: "",
                dialogDoctorAsistant: false,
                usersByCompany: []
            };
        },
        methods: {
            cleanData() {
                this.$refs.form.reset();
                this.covidPatient = new CovidPatient();
                this.valid = false;
                this.dialog = false;
                this.dialogDoctorAsistant = false;
            },
            newCovidPatient() {
                this.editedIndex = -1;
                this.valid = false;
                this.dialog = true;
                this.$refs.form.reset();
                this.covidPatient = new CovidPatient();
            },
            saveData() {
                if (this.$refs.form.validate()) {
                    this.covidPatient.userDoctor = this.covidPatient.userDoctor == "" ? null : this.covidPatient.userDoctor
                    this.covidPatient.userAsistant = this.covidPatient.userAsistant == "" ? null : this.covidPatient.userAsistant
                    if (this.editedIndex > -1) {
                        this.$store.dispatch('updateCovidPatient', this.covidPatient).then(
                            response => {
                                this.loadData();
                                this.cleanData();
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                                this.$store.state.dialogErrorMessage = 'No se pudo modificar el Paciente verifique información'
                            }
                        );
                    } else {
                        this.$store.dispatch('addCovidPatient', this.covidPatient).then(
                            response => {
                                this.loadData();
                                this.cleanData();
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                                this.$store.state.dialogErrorMessage = 'No se pudo crear el Paciente verifique que no exista'
                            }
                        );
                    }
                    this.dialog = false;
                }
            },
            editItem(item) {
                this.editedIndex = this.covidPatientList.indexOf(item);
                this.covidPatient = Object.assign({}, item);

                this.dialog = true;
            },
            editDoctorAsistant(item) {
                this.editedIndex = this.covidPatientList.indexOf(item);
                this.covidPatient = Object.assign({}, item);
                this.$store.dispatch('getUsersByCompany', this.covidPatient.company.id).then(response => {
                    this.usersByCompany = response
                    this.dialogDoctorAsistant = true;
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            deleteItem(item) {
                this.editedIndex = this.covidPatientList.indexOf(item);
                this.covidPatient = Object.assign({}, item);
                confirm('Está seguro de que quiere eliminar el registro?') &&
                this.$store.dispatch('deleteCovidPatient', this.covidPatient.id).then(response => {
                    this.loadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            loadData() {
                this.$store.dispatch('getCovidPatientsWithAlarmAndCompany').then(
                    response => {
                        this.covidPatientList = response.data
                        this.cleanData();
                        this.$store.state.progress = false;
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );
            },
            getAlarms(item) {
                this.editedIndex = this.covidPatientList.indexOf(item)
                this.covidPatient = Object.assign({}, item)
                this.$store.state.covidPatient = this.covidPatient
                this.$router.push({name: 'covidPatientAlarm'});
            },
            getEvolutions(item) {
                this.editedIndex = this.covidPatientList.indexOf(item)
                this.covidPatient = Object.assign({}, item)
                this.$store.state.covidPatient = this.covidPatient
                this.$router.push({name: 'covidPatientEvolution'});
            },
            loadAgency() {
                this.$store.dispatch('getCompanyAgenciesByCompany', this.covidPatient.company.id).then(response => {
                })
            },
            getCovidPatientAlarmReport() {
                this.$store.dispatch('generateReportCovidPatientAlarm').then(response => {
                    this.$store.state.progress = false;
                    this.urlDownloadReport = response.data
                    this.dialogDownloadReportAlarm = true
                })
            },
            getCovidPatientAlarmEvolutionReport() {
                this.$store.dispatch('generateReportCovidPatientEvolutionAlarm').then(response => {
                    this.$store.state.progress = false;
                    this.urlDownloadReport = response.data
                    this.dialogDownloadReportAlarm = true
                })
            },
            openDialogAptitudeWork(cpId) {
                this.showAptitudeWorkDialog = true;
                this.covidPatientId = cpId;
            },
            addAptitudeWork() {
                if (this.$refs.formMotivo.validate()) {
                    var aptitudeWork = {
                        comment: this.motivoCambioEstado,
                        covidPatientId: {id: this.covidPatientId}
                    };
                    this.$store.dispatch('addAptitudeWork', aptitudeWork).then(
                        response => {
                            this.showAptitudeWorkDialog = false;
                            this.loadData();
                        },
                        error => {
                            this.$store.state.progress = false;
                            this.$store.state.dialogError = true;
                            this.$store.state.dialogErrorMessage = 'No se pudo cambiar de estado al paciente.'
                        }
                    );
                    this.showAptitudeWorkDialog = false;
                }
            },
            getAptitudeWork(item) {
                this.editedIndex = this.covidPatientList.indexOf(item);
                this.covidPatient = Object.assign({}, item);
                this.$store.state.covidPatient = this.covidPatient;
                this.$router.push({name: 'aptitudeWork'});
            },
        },
        computed: {},
        created() {
            this.$store.dispatch('getCompanies').then(response => {
            }, error => {
                this.$store.state.dialogError = true
            })
            this.loadData()

        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/covid/CovidPatient.vue